<template>
  <div id="LetsCss">
    <template v-if="$route.query && $route.query.hideTemplate">
      <div>
        <VAppBar color="primary" >
          <VToolbarTitle>{{ getAppHeaderTitle ?? $route.name }}</VToolbarTitle>
        </VAppBar>
        <VMain>
          <RouterView />
        </VMain>
      </div>
    </template>
    <template v-else>
      <BaseAdminTemplate
        v-bind="{
          footerText
        }"
        :sidebar-list="filtedSidebarList"
      >
        <template #RightContent>
          {{getUser.user_named}}
          <!-- <ChangeLanguageBtn /> -->
        </template>
      </BaseAdminTemplate>
    </template>
  </div>
</template>

<script>
import BUSINESS_DATA from '@/configs/businessConstants';
import BaseAdminTemplate from './BaseAdminTemplate.vue'
import { mapGetters, mapState } from 'vuex';

export default {
  components: { BaseAdminTemplate },
  beforeRouteEnter (to, _from, next) {
    next((vm) => {
      if(vm.isStudent){
        // get current route name
        const currentRouteName = vm.$route.name
        // find the menu item that matches the current route name
        const menuItem = vm.menu.find(item => currentRouteName.startsWith(item.function_id))
        // if found, return the menu name
        if (menuItem) {
          vm.$store.commit('App/SET_APP_HEADER_TITLE',menuItem.mmenu_name)
        }
      }
    })
  },
  data () {
    return {
    }
  },
  computed:{
    ...mapGetters('Auth', [
      'getUser',
      'isStudent',
      'getUserAuthorityFunctionIDs',
      'getFilteredAuthorityFunctionIDs',
      'getUserDisabledRouteNames',
    ]),
    ...mapGetters('App', [
      'getAppHeaderTitle',
      'getAppHeaderColor',
      // 'getAppDocumentTitle',
      // 'getAppFullScreen'
    ]),
    ...mapState('Auth', ['menu']),
    footerText(){
      return BUSINESS_DATA.APP_FOOTER
    },
    mainSidebarList(){
      return  [
        {
          title: 'TOP',
          items: [
            {
              title: this.$t('auth.Login.tmp_orase'),
              to: { name: 'C00101' },
              functionId: 'C00101',
            },
            {
              title: this.$t('LetsAdminTemplate.7lIeZJZw_4uDdq6logH8Z'),
              to: { name: 'C00102' },
              functionId: 'C00102',
            },
          ]
        },
        {
          title: this.$t('LetsAdminTemplate.Ok6_JfU2DMj-9W5Cdt1GW'),
          items: [
            {
              title: this.$t('LetsAdminTemplate.qZqH9vNB_QwZtCA_L8O1U'),
              to: { name: 'C20201Browse' },
              functionId: 'C20201',
            },
            {
              title: this.$t('C40101.ScheduleTable.MvHr5weOTpl94zRIDzjRv'),
              to: { name: 'C20101Browse' },
              functionId: 'C20101',
            },
            {
              title: this.$t('LetsAdminTemplate.dFJBzkmmG0c1lFZ2FbxCI'),
              to: { name: 'C40411Browse' },
              functionId: 'C40411',
            },
            {
              title: this.$t('LetsAdminTemplate.-hdEzt2tnQ9r32ExpWd_X'),
              to: { name: 'C20301Browse' },
              functionId: 'C20301',
            },
            {
              title: this.$t('LetsAdminTemplate.5-vZf9rFI1UOADbn4FGtj'),
              // to: { name: 'C20301Browse' },
              functionId: 'C20401',
            },
          ]
        },
        {
          title: this.$t('LetsAdminTemplate.BLk9yf4zXF0RbSCxRfWdo'),
          items: [
            {
              title: this.$t('LetsAdminTemplate.zQvfkNRlimamPLfGgKg_s'),
              to: { name: 'C40501Browse' },
              functionId: 'C40501',
            },
            {
              title: this.$t('LetsAdminTemplate.bfJGqtnlxRq1spemSQKCp'),
              to: { name: 'C40101' },
              functionId: 'C40101',
            },
            {
              title: this.$t('LetsAdminTemplate.YcoOUeaXWLqlciYYd5rYj'),
              target: '_blank',
              to: { name: 'C40201', query: { hideTemplate: 1 } },
              functionId: 'C40201',
            },
            {
              title: this.$t('LetsAdminTemplate.KjSfDqb5QNEEPu9c4PDSV'),
              to: { name: 'C50101Browse' },
              functionId: 'C50101',
            },
          ]
        },
        {
          title: this.$t('LetsAdminTemplate.rHogqxlifWvpj7le8Li2J'),
          items: [
            {
              title: this.$t('LetsAdminTemplate.jq120uOW5iPXSKeKKYUi1'),
              // to: { name: 'C40401Browse' },
              functionId: 'C40401',
              forceHidden: true,
            },
            {
              title: this.$t('LetsAdminTemplate.b8ltJXce2kSUR8OlgwvXQ'),
              to: { name: 'C30101' },
              functionId: 'C30101',
            },
            {
              title: this.$t('LetsAdminTemplate.b59xgbfjIqJVRvvefrLQ4'),
              to: { name: 'C30201' },
              functionId: 'C30201',
            },
          ]
        },
        {
          title: this.$t('LetsAdminTemplate.qbYluVhFjxXIkZASDcpZo'),
          items: [
            {
              title: this.$t('LetsAdminTemplate.lsbbp-JfYBV50WkWyCB5F'),
              to: { name: 'C40701Browse' },
              functionId: 'C40701',
            },
            {
              title: this.$t('LetsAdminTemplate.-iNpXjX-pxxfinSZesCYO'),
              to: { name: 'C10201' },
              functionId: 'C10201',
            },
            {
              title: this.$t('LetsAdminTemplate.2kpAvimFZkpRoHx4K33yd'),
              to: { name: 'C10301' },
              functionId: 'C10301',
            },
            {
              title: this.$t('LetsAdminTemplate.hdacH20EsiUU9EZWz81x3'),
              to: { name: 'C10401' },
              functionId: 'C10401',
            },
            {
              title: this.$t('C20201.PendingSchedule.nYdWwR8qS_huz3nuNKQHa'),
              to: { name: 'C10101Browse' },
              functionId: 'C10101',
            },
          ]
        },
        {
          title: this.$t('LetsAdminTemplate.NhrWfDpnK1m0bN3rPBcbZ'),
          items: [
            {
              title: this.$t('LetsAdminTemplate.wFTL-5GQjNLU3IX1YxHan'),
              to: { name: 'M00101' },
              functionId: 'M00101',
            },
            {
              title: this.$t('LetsAdminTemplate.AD7cNmIRpTH1cgj4FoEea'),
              to: { name: 'M00201' },
              functionId: 'M00201',
            },
            {
              title: this.$t('LetsAdminTemplate.JyoWx5oZCLURKjwsZ87_L'),
              to: { name: 'M00501Browse' },
              functionId: 'M00501',
            },
            {
              title: this.$t('LetsAdminTemplate.bTMXPjUyOixuIIrMh0NAu'),
              to: { name: 'C00103' },
              functionId: 'C00103',
            },
            
          ]
        },
        {
          title: this.$t('LetsAdminTemplate.GaywY5zqvZhCZnY4v0hR2'),
          items: [
            {
              title: this.$t('LetsAdminTemplate.0l7XcxhODv7844IAC6a7f'),
              to: { name:'M20401Browse' },
              functionId: 'M20401',
            },
            {
              title: this.$t('LetsAdminTemplate.R9Sp9tXLbW4pKcycmbi36'),
              to: { name: 'M20201Browse' },
              functionId: 'M20201',
            },
            {
              title: this.$t('LetsAdminTemplate.TeASu8dnMTC1cK_i4EvbK'),
              to: { name:'M20901Browse' },
              functionId: 'M20901',
            },
            {
              title: this.$t('LetsAdminTemplate.jj7bphNLxguRqvliYSupG'),
              to: { name: 'PgM20601BatchEdit' },
              functionId: 'M20601',
            },

            {
              title: this.$t('LetsAdminTemplate.yKRZ8ULm-yTgI-QhujBBk'),
              to: { name: 'M20301' },
              functionId: 'M20301',
            },
            {
              title: this.$t('LetsAdminTemplate.6EkHNL0YJSjkDFFZZ1D87'),
              to: { name: 'M20101Browse' },
              functionId: 'M20101',
            },
            {
              title: this.$t('LetsAdminTemplate.aeoev2p1Z5wVna3EozNpk'),
              // to: { name: 'M20501' },
              functionId: 'M20501',
              forceHidden: true,
            },
           
          ]
        },
        {
          title: this.$t('LetsAdminTemplate.57sIO5tqU7MzyV9XvrOQK'),
          items: [
            {
              title: this.$t('LetsAdminTemplate.3W7K2yK3dVNHEb4B-MO6c'),
              to: { name: 'M21101Browse' },
              functionId: 'M21101',
            },
            {
              title: this.$t('LetsAdminTemplate.oHgVRWvyhmgthJljBlelW'),
              to: { name: 'M20801Browse' },
              functionId: 'M20801',
            },
            {
              title: this.$t('LetsAdminTemplate.fim69ZdQPwmMZhzlAesze'),
              to: { name: 'M20701Browse' },
              functionId: 'M20701',
            },
            {
              title: this.$t('LetsAdminTemplate.PQ4Sze96QncePp7bzqqBo'),
              to: { name: 'M21001Browse' },
              functionId: 'M21001',
            },
            {
              title: this.$t('LetsAdminTemplate.m21201SystemSettingManage'),
              to: { name: 'M21201Browse' },
              functionId: 'M21201',
            },
             {
              title: this.$t('M21301.front_page_name'),
              to: { name: 'M21301Browse' },
              functionId: 'M21301',
            },
            {
              title: this.$t('M21501.front_page_name'),
              to: { name: 'M21501Browse' },
              functionId: 'M21501',
            },
            {
              title: this.$t('M21601.front_page_name'),
              to: { name: 'M21601Browse' },
              functionId: 'M21601',
            },
          ]
        },
        {
          title: '',
          items: [
            // === 講師 === //
            {
              title: this.$t('LetsAdminTemplate.9PvEUObUOjNCzC1l18-py'),
              to: { name: 'C11101' },
              functionId: 'C11101',
            },
            {
              title: this.$t('LetsAdminTemplate.gt5BC31leEAWWJcfgs55U'),
              to: { name: 'C11201' },
              functionId: 'C11201',
            },
            {
              title: this.$t('LetsAdminTemplate.MUInX4rKBwN0rMDq2TbOu'),
              to: { name: 'C10201Teacher',
                params: {
                  teacher_no: this.getUser.teacher_no
                }
              },
              functionId: 'C10201',
            },
            {
              title: this.$t('LetsAdminTemplate.zFtBjbZ118kKNA8M6Qjw4'),
              to: { name: 'C50101TeacherBrowse' },
              functionId: 'C50101',
            },
            // === 生徒 === //
            {
              title: this.$t('LetsAdminTemplate.RhGO9lXPt_J67vZMtNQx2'),
              to: { name: 'C21101' },
            },
            {
              title: this.$t('LetsAdminTemplate.d08Pbxb8BmlBDbTwZg_Bu'),
              to: { name: 'C21201' },
            },
            {
              title: this.$t('C30101Student.PgC30101.XN09h0O8bB4VQQFmS-Y4a'),
              to: { name: 'C30101Student' },
            },
            {
              title: this.$t('LetsAdminTemplate.FfIHsZxERcR5XkJV6yAfK'),
              to: { name: 'C40501Browse' },
              functionId: 'C40501',
            },
            {
              title: this.$t('auth.Login.tmp_orase'),
              to: { name: 'C00101' },
            },
            {
              title: this.$t('LetsAdminTemplate.DhgiU08sTu4U-0NErghaR'),
              to: { name: 'C00103' },
              functionId: 'C00103',
            },
            {
              title: this.$t('C20201.PendingSchedule.nYdWwR8qS_huz3nuNKQHa'),
              to: { name: 'C10101Edit',
                params:{
                  teacher_id:this.getUser.user_id
                }
              },
              functionId: 'C10101',
            },
            {
              title: this.$t('LetsAdminTemplate.1CZeDvPnMJ-IFk_izZY39'),
              to: { name: 'C10402',
                query:{
                  teacher_no: this.getUser.teacher_no
                }
              },
              functionId: 'C10402',
            },
          ]
        },
        {
          title: 'Section_1',
          debug: true,
          items: [
            {
              title: 'Child_1.1',
              icon: 'mdi-view-dashboard',
              to: { name: '' },
              child: [
                {
                  title: 'Grandchild_1.1.1',
                  icon: 'mdi-view-dashboard',
                  to: { name: '' },
                }
              ]
            }
          ]
        },
      ]
    },
    filtedSidebarList(){
      // use value from database table
      if(this.isStudent){
        return [{
          title: '',
          items: [
            ...this.menu.map(item => {
              return {
                title: item.mmenu_name,
                to: { name: item.function_id },
              }
            }),
          ]
        }]
      }

      if (!this.getUserAuthorityFunctionIDs || this.getUserAuthorityFunctionIDs.length === 0) return []
      let filteredList = {}
      this.mainSidebarList.forEach(section => {
        section?.items.forEach(item => {
          const targetMenuItem = this.menu.find(menuItem => menuItem.function_id === item.functionId)
          let flag= false
          if (targetMenuItem)
            flag = true
          if(item.forceVisible) {
            flag = true
          } else if(item.forceHidden) {
            flag = false
          }
          if(flag){
            if (!filteredList[section.title])
              filteredList[section.title] = {
                ...section,
                items: []
              }
            // Remove disabled route, Should be deprecated in future
            if (this.getUserDisabledRouteNames.some((name) => item?.to?.name.includes(name))) delete item.to
            filteredList[section.title].items.push({
              ...item,
              // title: item.title+"-"+targetMenuItem.mmenu_name,
            })
          }
        })
      });
      // Only admin show section
      if (this.getUser.user_type_code < 400) {
        filteredList = Object.fromEntries(Object.entries(filteredList).filter(([key]) => key === ""))
      } else {
        filteredList = Object.fromEntries(Object.entries(filteredList).filter(([key]) => key !== ""))
      }
      return Object.values(filteredList)
    }
  },

  methods:{
  }
}
</script>

<style>

</style>
